import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import type Plan from 'modules/upsell/lib/selfUpsell/plans/Plan'
import { BUSINESS_VARIANT, ENTERPRISE_VARIANT } from 'modules/upsell/lib/selfUpsell/plans/utils'

import {
  OneSelector,
  RecruitmentSelector,
  ExpensesSeatsSelector,
  VariantOptionCard,
} from './components'
import { useVariantSelectorLogic } from './useVariantSelectorLogic'

type VariantSelectorProps = {
  addon: Plan
  crossSellingAddons?: Plan[] | undefined
  showPrice: boolean
  setSelectedAddonId: (id: string) => void
  installedAddonInternalId?: string | null
}

const VariantSelector = ({
  addon,
  crossSellingAddons,
  showPrice,
  setSelectedAddonId,
  installedAddonInternalId,
}: VariantSelectorProps) => {
  const {
    configPlan,
    period,
    currency,
    discount,
    seats,
    currentSeats,
    isExpenses,
    isRecruitment,
    isOne,
    installedOnePlan,
    includedSeatsPerModule,
    recruitmentOptions,
    oneSelectorOptions,
    isVariantAvailable,
    handleVariantChange,
    handlePlanChange,
    handleExpensesSeatsChange,
  } = useVariantSelectorLogic({
    addon,
    crossSellingAddons,
    setSelectedAddonId,
    installedAddonInternalId,
  })

  return (
    <Box gap="s6">
      {isRecruitment && (
        <RecruitmentSelector
          options={recruitmentOptions}
          selectedValue={addon.internalTitle}
          onPlanChange={handlePlanChange}
        />
      )}
      {isOne && (
        <OneSelector
          options={oneSelectorOptions}
          selectedValue={addon.internalTitle}
          onPlanChange={handlePlanChange}
        />
      )}
      {isExpenses() && (
        <ExpensesSeatsSelector
          seats={seats}
          currentSeats={currentSeats}
          includedSeatsPerModule={includedSeatsPerModule}
          onSeatsChange={handleExpensesSeatsChange}
        />
      )}
      <Text.Normal size="100" color="grey700" weight="medium">
        {isOne ? '' : i18n.t('self_upsell.first_step.select_plan_type')}
      </Text.Normal>
      <Box gap="s8">
        {isVariantAvailable(ENTERPRISE_VARIANT) && (
          <VariantOptionCard
            title={ENTERPRISE_VARIANT}
            isSelected={configPlan.variant === ENTERPRISE_VARIANT}
            showPrice={showPrice}
            showBestValueTag
            variant={addon.getSpecificVariant(ENTERPRISE_VARIANT)}
            period={period}
            currency={currency}
            seats={seats}
            currentSeats={currentSeats}
            discount={discount}
            onClick={() => handleVariantChange(ENTERPRISE_VARIANT)}
          />
        )}
        {isVariantAvailable(BUSINESS_VARIANT) && (
          <VariantOptionCard
            title={isOne ? addon.title : BUSINESS_VARIANT}
            isSelected={configPlan.variant === BUSINESS_VARIANT}
            showPrice={showPrice}
            variant={addon.getSpecificVariant(BUSINESS_VARIANT)}
            period={period}
            currency={currency}
            seats={seats}
            currentSeats={currentSeats}
            discount={discount}
            onClick={() => handleVariantChange(BUSINESS_VARIANT)}
          />
        )}
      </Box>
    </Box>
  )
}

export default VariantSelector
